import { styled } from 'dripsy';
import React, { memo } from 'react';
import { View } from 'react-native';

import { BaseText, Icon as AppIcon } from '@components';

const TextContainer = styled(View)({
  flexDirection: 'row',
  width: '100%',
  pt: '$6',
});

const LabelText = styled(BaseText)({
  minWidth: [147, 208],
  variant: 'text.medium',
  color: '$text400',
});

const DetailsText = styled(BaseText)({
  flex: 1,
  flexGrow: 1,
  width: '100%',
  variant: 'text.medium',
});

const Icon = styled(AppIcon)({
  mr: '$4',
});

interface IInfoProps {
  label: string;
  details: string;
  icon?: string;
}

export const TextRow = memo((props: IInfoProps) => {
  return (
    <TextContainer>
      <LabelText>{props.label}</LabelText>

      {props.icon && <Icon name={props.icon} size={20} />}
      <DetailsText>{props.details}</DetailsText>
    </TextContainer>
  );
});
